import styled from 'styled-components';
import { margin, padding, width } from './styledUtils';

export default styled.div(width, margin, padding);
